
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStkmedthodDialog extends Serenity.EntityDialog<IcStkmedthodRow, any> {
        protected getFormKey() { return IcStkmedthodForm.formKey; }
        protected getIdProperty() { return IcStkmedthodRow.idProperty; }
        protected getLocalTextPrefix() { return IcStkmedthodRow.localTextPrefix; }
        protected getNameProperty() { return IcStkmedthodRow.nameProperty; }
        protected getService() { return IcStkmedthodService.baseUrl; }
        protected getDeletePermission() { return IcStkmedthodRow.deletePermission; }
        protected getInsertPermission() { return IcStkmedthodRow.insertPermission; }
        protected getUpdatePermission() { return IcStkmedthodRow.updatePermission; }

        protected form = new IcStkmedthodForm(this.idPrefix);

    }
}